import createIcon from '../../createIcon';

/**
 * @component @name UnfoldMoreDouble
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDAwMiA3LjgzTDE1LjE3MDIgMTFMMTYuNTgwMiA5LjU5TDEyLjAwMDIgNUw3LjQxMDE2IDkuNTlMOC44MzAxNiAxMUwxMi4wMDAyIDcuODNaTTEyLjAwMDIgMi44M0wxNS4xNzAyIDZMMTYuNTgwMiA0LjU5TDEyLjAwMDIgMEw3LjQxMDE2IDQuNTlMOC44MzAxNiA2TDEyLjAwMDIgMi44M1pNMTIuMDAwMiAyMS4xN0w4LjgzMDE2IDE4TDcuNDIwMTYgMTkuNDFMMTIuMDAwMiAyNEwxNi41OTAyIDE5LjQxTDE1LjE3MDIgMThMMTIuMDAwMiAyMS4xN1pNMTIuMDAwMiAxNi4xN0w4LjgzMDE2IDEzTDcuNDIwMTYgMTQuNDFMMTIuMDAwMiAxOUwxNi41OTAyIDE0LjQxTDE1LjE3MDIgMTNMMTIuMDAwMiAxNi4xN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const UnfoldMoreDouble = createIcon('UnfoldMoreDouble', [
  [
    'path',
    {
      d: 'M12.0002 7.83L15.1702 11L16.5802 9.59L12.0002 5L7.41016 9.59L8.83016 11L12.0002 7.83ZM12.0002 2.83L15.1702 6L16.5802 4.59L12.0002 0L7.41016 4.59L8.83016 6L12.0002 2.83ZM12.0002 21.17L8.83016 18L7.42016 19.41L12.0002 24L16.5902 19.41L15.1702 18L12.0002 21.17ZM12.0002 16.17L8.83016 13L7.42016 14.41L12.0002 19L16.5902 14.41L15.1702 13L12.0002 16.17Z',
      key: 'egh0pb',
    },
  ],
]);

export default UnfoldMoreDouble;
